module.exports = __webpack_public_path__ + "static/media/am_Clubhaus02.1c436f0f.jpg";